import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import {
  IApiResponse,
  ICliente,
  IGetClientesQueryParams,
  IListaPaginada
} from 'src/app/interfaces';

@Injectable({
  providedIn: 'root'
})
export class ClienteService {
  private readonly baseURL = '/Cliente';
  constructor(private httpClient: HttpClient) {}

  getClientes(body: IGetClientesQueryParams) {
    return this.httpClient.post<IApiResponse<IListaPaginada<ICliente>>>(
      this.baseURL,
      body
    );
  }
}
